
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/cooperation",
      function () {
        return require("private-next-pages/partners/cooperation/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/cooperation"])
      });
    }
  